import { getWindowMetrics } from '../../../utils/helper';

export default function setIframeHeight(req, res) {
    const $iframe = req.srcIframe[0];
    const { value } = req;

    if ($iframe?.classList?.contains('apiv5')) {
        return;
    }

    if (!value.full && !('height' in value) && !('fullViewport' in value)) {
        res.event(2, 'Field height missing.');
        return;
    } if (value.full || value.fullViewport) {
        value.height = getWindowMetrics().AvailHeight;
        document.body.classList.add('no-scroll');
    } else {
        value.height = parseInt(value.height, 10);
        document.body.classList.remove('no-scroll');
    }

    if (Number.isNaN(value.height)) {
        req.event(1, 'Field height is not typeof number');
        return;
    }

    value.growOnly = value.growOnly !== false; // true als default

    if ($iframe && (!value.growOnly || parseInt($iframe.style.height, 10) < value.height)) {
        $iframe.style.height = `${value.height}px`;
    }
}
